import React, { useState, useEffect } from 'react';
import {ListItem, Icon, List} from "framework7-react";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import {setDefaultLang} from "../auth/authHelper";
import './LanguageSwitcher.css';

interface LSI {
    operator: string | undefined;
    languages: string[] | undefined;
    language: string | undefined;
}

const LanguageSwitcher: React.FC<LSI> = ({ languages, language }) => {
    const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language);

    const operatorLanguages = languages && languages.length > 0 ? languages : language ? [language] : ['en'];
    const { t } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        setDefaultLang(lng);
        setCurrentLanguage(lng);
    };

    useEffect(() => {
        const handleLanguageChange = (lng: string) => {
            setCurrentLanguage(lng);
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    useEffect(() => {
        i18n.changeLanguage(language || 'en');
    }, [language]);



    return (
        <List style={{listStyle: 'none'}}>
            <ListItem
                title={`${t("profile.language")}`}
                smartSelect
                smartSelectParams={{ openIn: 'sheet' }}
            >
                <Icon material="language" slot="media" />
                <select
                    name="language"
                    value={language}
                    onChange={(e) => changeLanguage(e.target.value)}
                >
                    {operatorLanguages.map((lng) => (
                        <option key={lng} value={lng}>
                            {lng}
                        </option>
                    ))}
                </select>
            </ListItem>
        </List>

    );
};

export default LanguageSwitcher;
